import {ChangeDetectionStrategy, Component, contentChildren, effect, input} from '@angular/core';
import {ButtonDirective} from '../../directives/button/button.directive';
import {ButtonSize} from '../../internal';

@Component({
  selector: 'ms-button-panel',
  templateUrl: './button-panel.component.html',
  styleUrls: ['./button-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[class.full-width]': 'fullWidth()',
  },
})
export class ButtonPanelComponent {
  readonly size = input<ButtonSize | null>(null);
  readonly fullWidth = input(false);

  readonly buttons = contentChildren(ButtonDirective);

  constructor() {
    effect(() => {
      this.applySize(this.size());
    });
  }

  private applySize(size: ButtonSize | null): void {
    if (size) {
      this.buttons().forEach(button => button.setPanelSize(size));
    }
  }
}
